<script lang="ts">import { Button } from "@infinitro/button";
import { stateUi } from "@infinitro/config";
import { loggedIn, toSiteUrl } from "@infinitro/global";
let { tabs = [], activeTab = $bindable(), width = null, size = "large", notSameSize = false, preserveScrollPosition = false, saveScrollPosition = null, borderRadius, borderRadiusContainer, shouldScrollIntoView = true, onChange } = $props();
$effect.pre(() => {
	if (activeTab === undefined) {
		activeTab = tabs.length > 0 ? tabs[0].value : "";
	}
});
let tabsContainer = $state(undefined);
let tabElements = $state([]);
const compactTabRadii = $derived($stateUi.tabs?.useCompactTabStripRadius ?? false);
const resolvedActiveTab = $derived(activeTab ?? tabs[0]?.value ?? "");
const resolvedBorderRadius = $derived(borderRadius ?? (compactTabRadii ? "8px" : "14px"));
const resolvedBorderRadiusContainer = $derived(borderRadiusContainer ?? (compactTabRadii ? "12px" : "16px"));
const buttonVariant = $derived($stateUi.tabs?.tabButtonsDefaultVariant ?? "secondary");
const useDarkActiveTabLabel = $derived($stateUi.tabs?.activeTabUsesDarkLabel ?? false);
function handleTabClick(_event, value) {
	if (preserveScrollPosition && saveScrollPosition) {
		saveScrollPosition(window.scrollY);
	}
	activeTab = value;
	const index = tabs.findIndex((tab) => tab.value === value);
	const tab = tabs[index];
	onChange?.({
		index,
		value,
		tab
	});
}
$effect(() => {
	const index = tabs.findIndex((tab) => tab.value === resolvedActiveTab);
	const activeTabElement = tabElements[index];
	if (shouldScrollIntoView && activeTabElement instanceof HTMLElement && tabsContainer) {
		activeTabElement.scrollIntoView({
			behavior: "smooth",
			inline: "center",
			block: "nearest"
		});
	}
});
</script>

<div
	class="tabs"
	style="width: {width ? width : 'auto'}; border-radius: {resolvedBorderRadiusContainer}"
	class:tabs-dark-active-label={useDarkActiveTabLabel}
	bind:this={tabsContainer}
>
	{#each tabs as tab, index (tab.value)}
		{#if (tab.link && tab.url) || (!tab.link && tab.value)}
			<!-- eslint-disable svelte/no-navigation-without-resolve -->
			<a
				href={tab.url ? toSiteUrl(tab.url, $loggedIn) : 'javascript:void(0);'}
				style="text-decoration: none; cursor: pointer; width: 100%; {tab.minWidthPx
					? `min-width: ${tab.minWidthPx}px;`
					: ''}"
				bind:this={tabElements[index]}
			>
				<Button
					text={tab.label}
					className="tab {tab.value === resolvedActiveTab ? 'active' : ''}"
					variant={buttonVariant}
					styleCustom={`border-radius: ${resolvedBorderRadius}; padding-left: 0.5rem; padding-right: 0.5rem; ${tab.minWidthPx ? `min-width: ${tab.minWidthPx}px;` : ''}`}
					onClick={(e) => handleTabClick(e, tab.value)}
					minWidth={false}
					icon={$stateUi.layout.useRemoteIcons === true && tab.remoteIcon
						? tab.remoteIcon
						: tab.icon}
					fullWidth={!notSameSize}
					activeTab={tab.value === resolvedActiveTab}
					inactiveTab={tab.value !== resolvedActiveTab}
					id={tab.id || tab.value.toString()}
					{size}
					iconCustomStyles="width:20px;height:20px"
					whiteSpace="nowrap"
				>
					{#snippet right_slot()}
						{#if tab.quantity}
							<span class="quantity">
								{tab.quantity || 0}
							</span>
						{/if}
					{/snippet}
				</Button>
			</a>
			<!-- eslint-enable svelte/no-navigation-without-resolve -->
		{/if}
	{/each}
</div>

<style>
	div.tabs {
		display: flex;
		align-items: center;
		gap: 0.5rem;
		border-radius: 16px;
}
	.tabs {
		z-index: 10;
		font-size: 0.875rem;
		line-height: 1.25rem;
		font-weight: 800;
		text-transform: uppercase;
		--tw-text-opacity: 1;
		color: rgb(229 231 235 / var(--tw-text-opacity, 1));
		margin-top: 0 !important;
}
	.quantity {
		margin-left: 0.5rem;
		display: flex;
		height: 1rem;
		min-width: 1rem;
		align-items: center;
		justify-content: center;
		border-radius: 5px;
		background-color: var(--color-primary-500);
		padding: 0.25rem;
		font-size: 0.55rem;
		--tw-text-opacity: 1;
		color: rgb(0 0 0 / var(--tw-text-opacity, 1));
}

	:global(.category-item .tabs a button p) {
		white-space: nowrap;
	}
	:global(.category-item .tabs a) {
		flex: 0;
	}
	:global(.category-item .tabs a button) {
		padding: 0 1rem !important;
	}

	:global(.tabs.tabs-dark-active-label a button.tab.active:not(.inactive-tab)) {
		--tw-text-opacity: 1;
		color: rgb(0 0 0 / var(--tw-text-opacity, 1));
}

	:global(.tabs.tabs-dark-active-label a button.tab.active:not(.inactive-tab) .remote-icon) {
		color: black !important;
	}
</style>
